import { render, staticRenderFns } from "./MobileCommunity.vue?vue&type=template&id=1f640faa&scoped=true&"
import script from "./MobileCommunity.vue?vue&type=script&lang=js&"
export * from "./MobileCommunity.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunity.vue?vue&type=style&index=0&id=1f640faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f640faa",
  null
  
)

export default component.exports